import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import avatar from '../img/ava-4.png';
import { FaTelegramPlane, FaInstagram, FaTwitter } from "react-icons/fa";
import { IoMdPerson, IoIosApps, IoMdCall } from "react-icons/io";



export default class Navigation extends Component {
    constructor(props){
        super(props)
        this.burgerClick = this.burgerClick.bind(this)
    }
    burgerClick(){
        const menuBtn = document.querySelector('.burger');
        const nav = document.querySelector('.nav');
        const navTop = document.querySelector('.nav__top');
        

        menuBtn.classList.toggle('burger__open');
        menuBtn.classList.toggle('burger__move');
        nav.classList.toggle('nav__move');
        navTop.classList.toggle('nav__top--hide');
        document.querySelector('.icon-1').classList.toggle('icon--move');
        document.querySelector('.icon-2').classList.toggle('icon--move');
        document.querySelector('.icon-3').classList.toggle('icon--move');
        
    }
    burgerClickAlt(){
        const menuBtn = document.querySelector('.burger');
        const nav = document.querySelector('.nav');
        const navTop = document.querySelector('.nav__top');

        menuBtn.classList.add('burger__open');
        menuBtn.classList.add('burger__move');
        nav.classList.add('nav__move');
        navTop.classList.add('nav__top--hide');
        
        document.querySelector('.icon-1').classList.add('icon--move');
        document.querySelector('.icon-2').classList.add('icon--move');
        document.querySelector('.icon-3').classList.add('icon--move');
    }
    
    render() {
        return (
            <React.Fragment>
                <nav className="nav">
                    <div className="burger" onClick={this.burgerClick}>
                        <span className="burger__line"></span>
                    </div>
                    <div className="nav__top">
                        <img className="nav__img" src={avatar} alt="avatar"/>
                        <p className="nav__name"> Karimov Jamshid</p>
                        <span className="nav__prof">Front-end Developer</span>
                        <div className="social">
                            <a className="social__link" target="_blank" rel="noopener noreferrer" href="https://t.me/Karimov_Jamshid"><FaTelegramPlane/></a>
                            <a className="social__link" target="_blank" rel="noopener noreferrer" href="https://t.me/Karimov_Jamshid"><FaInstagram/></a>
                            <a className="social__link" target="_blank" rel="noopener noreferrer" href="https://t.me/Karimov_Jamshid"><FaTwitter/></a>
                        </div>
                    </div>
                    <div className="nav-main">
                        <div className="nav-main__item">
                            <Link to="/" className="nav-main__link" onClick={this.burgerClickAlt} >
                                <IoIosApps className="nav-main__icons icon-1"  title="Work"/>
                                <h3 className="nav-main__title">Work</h3>
                            </Link>
                            <Link to="/landing" className="nav-main__link" onClick={this.burgerClickAlt}>
                                <span>Landing pages</span>
                            </Link>
                            <Link to="/ecommerce" className="nav-main__link" onClick={this.burgerClickAlt}>
                                <span>E-commerce</span>
                            </Link>

                            <Link to="/about" className="nav-main__link" onClick={this.burgerClickAlt}>
                                <IoMdPerson className="nav-main__icons icon-2" title="About"/>
                                <h3 className="nav-main__title">About</h3>
                            </Link>
                            <Link to="/education" className="nav-main__link" onClick={this.burgerClickAlt}>
                                <span>Education</span>
                            </Link>
                            <Link to="/skills" className="nav-main__link" onClick={this.burgerClickAlt}>
                                <span>Skills</span>
                            </Link>

                            <Link to="/contact" className="nav-main__link" onClick={this.burgerClickAlt}>
                                <IoMdCall className="nav-main__icons icon-3" title="Contact"/>
                                <h3 className="nav-main__title">Contact</h3>
                            </Link>
                        
                        </div>
                    </div>
                
                {/* <div>Icons made by <a href="https://www.flaticon.com/authors/pixel-perfect" title="Pixel perfect">Pixel perfect</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div> */}
                </nav>
            </React.Fragment>
           
        )
    }
}



